import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "no";
    return localStorage.getItem("lbs_lang") || "no";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("lbs_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const toggle = () => setLang((l) => (l === "no" ? "en" : "no"));
  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
